import React, { FC } from 'react';
import { useRouter } from 'next/router';
import AccountLinkingModals from '@components/accountLinking/modals';
import { getAccessToken } from '@repository/AccessToken';

const AccountLinking: FC = () => {
  const { query } = useRouter();

  if (!query?.publicKey || !query?.positionId) return null;
  if (!getAccessToken()) return null;

  const positionId = Number(query.positionId);
  const publicKey = `${query.publicKey}`;

  return (
    <>
      <AccountLinkingModals positionId={positionId} publicKey={publicKey} />
    </>
  );
};

export default AccountLinking;
